export default {"src":"/_next/static/media/call-icon.3841cb94.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};